import { useEffect } from 'react';

declare global {
  interface Window {
    fbq?: (command: string, event: string, params?: Record<string, unknown>) => void;
  }
}

export function useMetaPixel(event: 'Lead' | 'ViewContent' | 'PageView', params?: Record<string, unknown>) {
  useEffect(() => {
    const firePixelEvent = () => {
      if (typeof window !== 'undefined' && window.fbq) {
        try {
          window.fbq('track', event, params);
          console.log(`✅ Meta Pixel ${event} event fired successfully`, params);
        } catch (error) {
          console.error('❌ Error firing Meta Pixel event:', error);
        }
      } else {
        console.warn('⚠️ Meta Pixel (fbq) not available yet, retrying...');
        setTimeout(firePixelEvent, 100);
      }
    };

    const timer = setTimeout(firePixelEvent, 100);
    return () => clearTimeout(timer);
  }, [event, JSON.stringify(params)]);
}
